export const makeGoogleMapsUrl = (
  companyName: string | undefined,
  country: string | undefined,
  city: string | undefined,
  address: string | undefined,
) => {
  const url = new URL(
    `https://www.google.com/maps/search/?api=1&query=${companyName}+${country}+${city}+${address}`,
  );
  const googleMapsUrl = url.toString();
  return googleMapsUrl;
};
